//TODO: Refactoring...
document.addEventListener('DOMContentLoaded', function () {
  const ele = document.querySelectorAll('.tab-wrap')
  if (!ele) return

  ele.forEach((tab, index) => {
    let tabElements = tab.querySelectorAll('.brand-tab-element')
    var contentEls = tab.querySelectorAll('.brand-tab-screen')

    contentEls[0].classList.add('brand-tab-screen--active')

    tabElements.forEach((element) => {
      let tabIndex = element.getAttribute('tabindex')

      element.addEventListener('click', (event) => {
        let tabScreenIndex = element.getAttribute('tabindex')
        tabElements.forEach((tabElement, index) => {
          if (tabElement.classList.contains('is-active')) {
            tabElement.classList.remove('is-active')
          }
          if (tabScreenIndex == index) {
            tabElement.classList.add('is-active')
          }
        })
        contentEls.forEach((contentEl, index) => {
          if (contentEl.classList.contains('brand-tab-screen--active')) {
            contentEl.classList.remove('brand-tab-screen--active')
          }
          if (tabScreenIndex == index) {
            contentEl.classList.add('brand-tab-screen--active')
          }
        })
      })
    })
  })
})
